<template>
  <div>
    <pc-header :isTransparent.sync="isTransparent"></pc-header>

    <div class="honor">
      <div class="content">
        <img alt src="~@/assets/pc/honor-certificate-01.jpg" />
        <img alt src="~@/assets/pc/honor-certificate-02.jpg" />
        <img alt src="~@/assets/pc/honor-certificate-03.jpg" />
      </div>
    </div>
  </div>
</template>

<script>
import pcHeader from "@/components/pcHeader"

export default {
  metaInfo: {
    title: "荣誉资质|东阳光冬虫夏草官网",
    meta: [
      {
        name: "keywords",
        content: "关键字"
      },
      {
        name: "description",
        content: "网页描述"
      }
    ]
  },
  components: {
    "pc-header": pcHeader
  },
  data () {
    return {
      isTransparent: true // 是否透明
    }
  }
}
</script>

<style scoped lang="stylus">
.honor {
  width: 100%;
  display: flex;
  justify-content: center;

  .content {
    width: 50%;

    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// pcHonor.vue